import { Space, Typography } from "antd";
import { AddFinanceCostsDrawer } from "components/Drawers/AddFinanceCostsDrawer/AddFinanceCostsDrawer.tsx";
import { DetailFinanceCostDrawer } from "components/Drawers/DetailFinanceCostDrawer/DetailFinanceCostDrawer.tsx";
import { data, DataItem } from "components/Tables/FinanceBonusesTable/mock.ts";
import { Table } from "components/UI/Table";
import { TableColumnType } from "components/UI/Table/types/table.ts";
import { ColumnHeaderTitle } from "components/UI/Table/UI/ColumnHeaderTitle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useRowHandlers } from "hooks/useTableRowHandlers.tsx";
import { useState } from "react";
import Flag from "react-world-flags";
import { PermissionEnum } from "types/enums";
import { DrawerId, TableId } from "types/models.ts";

import PaginationResponse = App.Http.Responses.PaginationResponse;

interface FinanceBonusesResponse {
    bonuses: DataItem[];
    pagination: PaginationResponse;
}

export const FinanceBonusesTable = () => {
    const tableId = TableId.FinanceBonusesTable;
    const { t } = usePaldockTranslation("tables.finance-bonuses");
    const { t: tG } = usePaldockTranslation("tables.general-columns");
    const { t: tC } = usePaldockTranslation("common");
    const [tableData, setTableData] = useState<DataItem[]>(data);

    const handleAddFinance = (newItem: DataItem) => {
        setTableData((prevData) => [...prevData, newItem]);
    };

    const mockData: FinanceBonusesResponse = {
        bonuses: tableData,
        pagination: {
            currentPage: 1,
            perPage: 30,
            total: 1,
            totalPages: 1,
            previousPage: null,
            nextPage: null,
            from: 1,
            to: 1,
            maxResults: 1000,
        },
    };
    const mockResponse = {
        data: mockData,
    };

    const { getRowHandlers, getRowClassName } = useRowHandlers<DataItem>({
        actions: [
            {
                type: "drawer",
                drawerId: DrawerId.DetailFinanceCost,
                permission: PermissionEnum.FinanceBonusView,
                drawerParam: `${DrawerId.ParentField}-costId`,
            },
        ],
    });

    const columnConfig: TableColumnType<DataItem>[] = [
        {
            title: <ColumnHeaderTitle columnTitle={tG("date")} />,
            dataIndex: "datum",
            key: "datum",
            // TODO - BE allow sort
            // sorter: true,
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("user")} />,
            dataIndex: "uzivatel",
            key: "uzivatel",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("country")} />,
            dataIndex: "flagCode",
            key: "flagCode",
            render: (text) => (
                <Space>
                    <Flag code={text} className={"h-[13px] rounded-[3px]"} />
                </Space>
            ),
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("category")} />,
            dataIndex: "kategorie",
            key: "kategorie",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("offer")} />,
            dataIndex: "nabidka",
            key: "nabidka",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("type")} />,
            dataIndex: "typ",
            key: "typ",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("id")} />,
            dataIndex: "id",
            key: "id",
            align: "right",
        },
        {
            title: <ColumnHeaderTitle columnTitle={t("columns.reward")} />,
            dataIndex: "odmena",
            key: "odmena",
            align: "right",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tC("amount")} />,
            dataIndex: "castka",
            key: "castka",
            align: "right",
            render: (text) => <Typography.Text>${text}</Typography.Text>,
        },
    ];

    return (
        <>
            <AddFinanceCostsDrawer handleAdd={handleAddFinance} />
            <DetailFinanceCostDrawer />
            <Table<FinanceBonusesResponse, DataItem>
                tableId={tableId}
                data={mockResponse.data}
                dataSource={mockResponse.data.bonuses}
                columnConfig={columnConfig}
                loading={false}
                rowKey={(record) => record.id}
                addEntityData={{
                    drawerId: DrawerId.AddFinanceCost,
                }}
                showRefetchButton={true}
                onRow={(record, rowIndex) => getRowHandlers(record, rowIndex)}
                rowClassName={(_, rowIndex) => getRowClassName(rowIndex)}
            />
        </>
    );
};
